import { Injectable } from '@angular/core';
import { apiUrl } from '../schema/api-url';
import { APIService } from './master/api.service';
import { BaseService } from './master/base.service';

@Injectable({
  providedIn: 'root'
})

export class DmDungChungService extends BaseService {

    constructor(private _apiService: APIService) {
        super(_apiService);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách quan hệ với chủ hộ 
     */
    getDsQuanHeChuHo() {
      return super.get(apiUrl.danhMuc.quanHeVoiCH);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách quan hệ với chủ hộ (không có chủ hộ)
     */
     getDsQuanHeKhongCoChuHo() {
      return super.get(apiUrl.baoTro.quanHeVoiCHKhongCoCH);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách dân tộc
     */
    getDsDanToc() {
      return super.get(apiUrl.danhMuc.danToc);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách tình trạng nhà ở
     */
    getDsTinhTrangNhaO() {
      return super.get(apiUrl.danhMuc.tinhTrangNhaO);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách vật liệu cột nhà
     */
    getDsVatLieuCotNha(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsVatLieuCotNha, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách vật liệu mái nhà
     */
    getDsVatLieuMaiNha(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsVatLieuMaiNha, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách tài săn bền lâu
     */
    getDsTaiSanBenLau(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsTaiSanBenLau, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh mục động vật chăn nuôi
     */
    getDsChanNuoi(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsChanNuoi, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách các loại đất đai
     */
    getDsDatDai(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsDatDai, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh mục các nguyên nhân khó khăn
     */
    getDsNguyenNhanKhoKhan() {
      return super.get(apiUrl.baoTro.dsNguyenNhanKhoKhan);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách vật liệu tường nhà
     */
    getDsVatLieuTuongNha(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.baoTro.dsVatLieuTuongNha, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách loại hố xí
     */
    getDsLoaiHoXi() {
      return super.get(apiUrl.danhMuc.loaiHoXi);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách loại điện
     */
    getDsLoaiDien() {
      return super.get(apiUrl.danhMuc.loaiDien);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách hình thức sở hữu nhà ở
     */
    getDsHinhThucSoHuuNhaO() {
      return super.get(apiUrl.danhMuc.soHuuNhaO);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách nước sinh hoạt
     */
    getDsNuocSinhHoat(maGiaiDoan?: any) {
      const params = maGiaiDoan ? { maGiaiDoan: maGiaiDoan } : {};
      return super.get(apiUrl.danhMuc.nuocSinhHoat, params);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách phân loại hộ nghèo
     */
    getPhanLoaiHoNgheo() {
      return super.get(apiUrl.danhMuc.phanLoaiHoNgheo);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param loaiHo
     * @description Danh sách chi tiết hộ nghèo
     */
    getDsChiTietHoNgheo(loaiHo) {
      return super.get(apiUrl.danhMuc.chiTietHoNgheo + loaiHo);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách loại đối tượng
     */
    getDsLoaiDoiTuong() {
      return super.get(apiUrl.danhMuc.danhMucDoiTuong);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param maChinhSach
     * @description Danh sách loại đối tượng theo chính sách
     */
    getDsLoaiDoiTuongTheoChinhSach(maChinhSach) {
      return super.get(apiUrl.danhMuc.danhMucDoiTuong, { maChinhSach: maChinhSach } );
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Danh sách đối tượng thuộc chính sách
     */
    getDsDoiTuongThuocChinhSach(requestBody) {
      return super.post(apiUrl.danhMuc.doiTuongThuocCS, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách tình trạng việc làm
     */
    getDsTinhTrangViecLam() {
      return super.get(apiUrl.danhMuc.tinhTrangViecLam);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách đối tượng chính sách
     */
    getDsDoiTuongChinhSach() {
      return super.get(apiUrl.danhMuc.doiTuongChinhSach);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách tình trạng hôn nhân
     */
    getDsTinhTrangHonNhan() {
      return super.get(apiUrl.danhMuc.tinhTrangHonNhan);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách đối tượng chính sách
     */
    getDsCapHoc() {
      return super.get(apiUrl.danhMuc.capHoc);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách loại thẻ BHYT
     */
    getDsLoaiTheBHYT() {
      return super.get(apiUrl.danhMuc.loaiTheBHYT);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách lý do không khám chữa bệnh
     */
    getDsLyDoKhongKCB() {
      return super.get(apiUrl.danhMuc.lyDoKhongKCB);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách trình độ học vấn
     */
    getDsTrinhDoHocVan() {
      return super.get(apiUrl.danhMuc.trinhDoHocVan);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách mức độ khuyết tật
     */
    getDsMucDoKhuyetTat() {
      return super.get(apiUrl.danhMuc.dsMucDoKhuyetTat);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách trình độ học vấn module trẻ em
     */
    getTrinhDoHocVan() {
      return super.get(apiUrl.danhMuc.danhMucTrinhDo);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách tình trạng học tập module trẻ em
     */
    getDanhMucTinhTrangHocTap() {
      return super.get(apiUrl.danhMuc.danhMucTinhTrangHocTap);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh sách mã hoạt động
     */
    getDsMaHoatDong() {
      return super.get(apiUrl.danhMuc.danhMucHoatDong);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh mục chức danh
     */
    getDanhMucChucDanh() {
      return super.get(apiUrl.danhMuc.danhMucChucDanh);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh mục dạng tật
     */
    getDanhMucDangTat() {
      return super.get(apiUrl.baoTro.listDangTat);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Danh mục đơn vị
     */
    getDanhMucDonVi(requestBody) {
      return super.post(apiUrl.danhMuc.timKiemDonVi, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục đơn vị
     */
    themMoiDonVi(requestBody) {
      return super.post(apiUrl.danhMuc.themMoiDonVi, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method PUT
     * @param requestBody
     * @description Cập nhật danh mục đơn vị
     */
    capNhatDonVi(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatDonVi, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param maDonVi
     * @description Xóa danh mục đơn vị
     */
    xoaDonVi(maDonVi) {
      return super.delete(apiUrl.danhMuc.xoaDonVi, { maDonVi: maDonVi });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Danh mục cấp đơn vị
     */
    getDanhMucCapDonVi() {
      return super.get(apiUrl.danhMuc.danhMucCapDonVi);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục cấp đơn vị
     */
    themMoiCapDonVi(requestBody) {
      return super.post(apiUrl.danhMuc.themMoiCapDonVi, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Danh mục phòng ban
     */
    getDanhMucPhongBan(requestBody) {
      return super.post(apiUrl.danhMuc.timKiemPhongBan, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục phòng ban
     */
    themMoiPhongBan(requestBody) {
      return super.post(apiUrl.danhMuc.themMoiPhongBan, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method PUT
     * @param requestBody
     * @description Cập nhật danh mục phòng ban
     */
    capNhatPhongBan(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatPhongBan, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param maPhongBan
     * @description Xóa danh mục phòng ban
     */
    xoaPhongBan(maPhongBan) {
      return super.delete(apiUrl.danhMuc.xoaPhongBan, { maPhongBan: maPhongBan });
    }

    /**
     * @author toitv.tgg
     * @method GET
     * @param topic
     * @description Danh mục notification
     */
    getDanhMucNotification(topic) {
      return super.get(apiUrl.danhMuc.notification, { topic : topic });
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục quan hệ
     */
    timKiemQuanHe(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemQuanHe, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục quan hệ
     */
    themQuanHe(requestBody) {
      return super.post(apiUrl.danhMuc.themQuanHe, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục quan hệ
     */
    capNhatQuanHe(requestBody) {
      return super.post(apiUrl.danhMuc.capNhatQuanHe, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param { maQuanHe, trangThaiXoa }
     * @description Xóa danh mục quan hệ
     */
    xoaQuanHe(maQuanHe, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaQuanHe, { maQuanHe: maQuanHe, trangThaiXoa: trangThaiXoa });
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục khu vực
     */
    timKiemKhuVuc(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemKhuVuc, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục khu vực
     */
    themKhuVuc(requestBody) {
      return super.post(apiUrl.danhMuc.themKhuVuc, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục khu vực
     */
    capNhatKhuVuc(requestBody) {
      return super.post(apiUrl.danhMuc.capNhatKhuVuc, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param { maKhuVuc, trangThaiXoa }
     * @description Xóa danh mục khu vực
     */
    xoaKhuVuc(maKhuVuc, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaKhuVuc, { maKhuVuc: maKhuVuc, trangThaiXoa: trangThaiXoa });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all danh mục khu vực
     */
    getAllKhuVuc() {
      return super.get(apiUrl.danhMuc.getAllKhuVuc);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục vùng kinh tế
     */
    timKiemVungKt(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemVungKt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục vùng kinh tế
     */
    themVungKt(requestBody) {
      return super.post(apiUrl.danhMuc.themVungKt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục vùng kinh tế
     */
    capNhatVungKt(requestBody) {
      return super.post(apiUrl.danhMuc.capNhatVungKt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param { maVungKinhTe, trangThaiXoa }
     * @description Xóa danh mục vùng kinh tế
     */
    xoaVungKt(maVungKinhTe, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaVungKt, { maVungKinhTe: maVungKinhTe, trangThaiXoa: trangThaiXoa });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all danh mục vùng kinh tế
     */
    getAllVungKt() {
      return super.get(apiUrl.danhMuc.getAllVungKt);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục lương tối thiểu
     */
    timKiemLuongTt(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemLuongTt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục lương tối thiểu
     */
    themLuongTt(requestBody) {
      return super.post(apiUrl.danhMuc.themLuongTt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục lương tối thiểu
     */
    capNhatLuongTt(requestBody) {
      return super.post(apiUrl.danhMuc.capNhatLuongTt, requestBody);
    }

    /**
     * @author hangdtt.it5
     * @method DELETE
     * @param { idLuongVung, trangThaiXoa }
     * @description Xóa danh mục lương tối thiểu
     */
    xoaLuongTt(idLuongVung, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaLuongTt, { idLuongVung: idLuongVung, trangThaiXoa: trangThaiXoa });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all danh mục lương tối thiểu
     */
    getAllLuongTt() {
      return super.get(apiUrl.danhMuc.getAllLuongTt);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all trình độ văn hóa
     */
    getAllTrinhDoVanHoa() {
      return super.get(apiUrl.danhMuc.getAllTrinhDoVanHoa);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all loại đối tượng BTXH
     */
     getAllDoiTuongBTXH() {
      return super.get(apiUrl.danhMuc.getAllDoiTuongBTXH);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all loại việc làm
     */
    getAllLoaiViecLam() {
      return super.get(apiUrl.danhMuc.getAllLoaiViecLam);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all loại công việc làm công ăn lương
     */
    getAllViecLamCongAnLuong() {
      return super.get(apiUrl.danhMuc.getAllViecLamCongAnLuong);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all danh mục đối tượng phục vụ
     */
    doiTuongPhucVu() {
      return super.get(apiUrl.baoTro.doiTuongPhucVu);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get all danh mục loại hình trung tâm
     */
    getLoaiHinhTrungTam() {
      return super.get(apiUrl.baoTro.loaiHinhTrungTam);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param idLoaiHinh
     * @description Get all danh mục chi tiết loại hình trung tâm
     */
    chiTietLoaiHinh(idLoaiHinh) {
      return super.get(apiUrl.baoTro.chiTietLoaiHinh, { idLoaiHinh: idLoaiHinh });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param { maTinh, capDonVi }
     * @description Get all danh mục chi tiết loại hình trung tâm
     */
    trungTamTrucThuoc(maTinh, capDonVi) {
      if (maTinh == null && capDonVi == null) {
        return super.get(apiUrl.baoTro.trungTamTrucThuoc);
      } else {
        return super.get(apiUrl.baoTro.trungTamTrucThuoc, { maTinh: maTinh, capDonVi: capDonVi });
      }
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get danh sách trạng thái đổi tượng tại trung tâm
     */
    trangThaiDoiTuongTaiTrungTam() {
      return super.get(apiUrl.baoTro.trangThaiDoiTuongTaiTrungTam);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get danh sách loại đổi tượng tại trung tâm
     */
    loaiDoiTuong() {
      return super.get(apiUrl.baoTro.loaiDoiTuong);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param idLoaiDoiTuong
     * @description Get danh sách đổi tượng tại trung tâm
     */
    chiTietDoiTuong(idLoaiDoiTuong) {
      return super.get(apiUrl.baoTro.chiTietDoiTuong, { idLoaiDoiTuong: idLoaiDoiTuong });
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get danh sách hình thức lưu trú
     */
    hinhThucLuuTru() {
      return super.get(apiUrl.baoTro.hinhThucLuuTru);
    }

    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get danh sách các dịch vụ được cung cấp
     */
    dichVuDuocCungCap() {
      return super.get(apiUrl.baoTro.dichVuDuocCungCap);
    }



    /**
     * @author hangdtt.it5
     * @method GET
     * @param
     * @description Get danh sách loại đối tượng khi thêm mới/ cập nhật thành viên
     */
    loaiDoiTuongThanhVien() {
      return super.get(apiUrl.baoTro.loaiDoiTuongThanhVien);
    }

    getAllCoSoDaoTao(){
      return super.get(apiUrl.danhMuc.getAllCoSoDaoTao);
    }

    //Danh mục chăn nuôi
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục chăn nuôi
     */
    timKiemChanNuoi(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemChanNuoi, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục chăn nuôi
     */
    themChanNuoi(requestBody) {
      return super.post(apiUrl.danhMuc.themChanNuoi, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục chăn nuôi
     */
    capNhatChanNuoi(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatChanNuoi, requestBody);
    }

    /**
     * @author psdung
     * @method DELETE
     * @param { maQuanHe, trangThaiXoa }
     * @description Xóa danh mục chăn nuôi
     */
    xoaChanNuoi(uuidDanhMuc, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaChanNuoi, { uuidDanhMuc: uuidDanhMuc, trangThaiXoa: trangThaiXoa });
    }

    //Danh mục trồng trọt
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục cây trồng
     */
    timKiemTrongTot(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemTrongTrot, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục loại cây trồng
     */
    getAllLoaiCayTrong() {
      return super.get(apiUrl.danhMuc.getAllLoaiCayTrong);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục trồng trọt
     */
    themTrongTrot(requestBody) {
      return super.post(apiUrl.danhMuc.themTrongTrot, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục trồng trọt
     */
    capNhatTrongTrot(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatTrongTrot, requestBody);
    }

    /**
     * @author psdung
     * @method DELETE
     * @param { maQuanHe, trangThaiXoa }
     * @description Xóa danh mục trồng trọt
     */
    xoaTrongTrot(uuidDanhMuc, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaTrongTrot, { uuidDanhMuc: uuidDanhMuc, trangThaiXoa: trangThaiXoa });
    }

    //Danh mục ngành nghề
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục ngành nghề
     */
    timKiemNganhNghe(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemNganhNghe, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục nhóm ngành
     */
    getAllNhomNganh() {
      return super.get(apiUrl.danhMuc.getAllNhomNganhNghe);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục ngành nghề
     */
    themNganhNghe(requestBody) {
      return super.post(apiUrl.danhMuc.themNganhNghe, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục ngành nghề
     */
    capNhatNganhNghe(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatNganhNghe, requestBody);
    }

    /**
     * @author psdung
     * @method DELETE
     * @param { maQuanHe, trangThaiXoa }
     * @description Xóa danh mục ngành nghề
     */
    xoaNganhNghe(uuidDanhMuc, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaNganhNghe, { uuidDanhMuc: uuidDanhMuc, trangThaiXoa: trangThaiXoa });
    }

     //Danh mục khác
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục khác
     */
    timKiemKhac(requestBody) {
      return super.post(apiUrl.danhMuc.timkiemKhac, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục khac
     */
    themKhac(requestBody) {
      return super.post(apiUrl.danhMuc.themKhac, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục khac
     */
    capNhatKhac(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatKhac, requestBody);
    }

    /**
     * @author psdung
     * @method DELETE
     * @param { maQuanHe, trangThaiXoa }
     * @description Xóa danh mục khac
     */
    xoaKhac(uuidDanhMuc, trangThaiXoa) {
      return super.delete(apiUrl.danhMuc.xoaKhac, { uuidDanhMuc: uuidDanhMuc, trangThaiXoa: trangThaiXoa });
    }

    //Danh mục mức xác định
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Tìm kiếm danh mục mức xác định
     */
    timKiemMucXacDinh() {
      return super.get(apiUrl.danhMuc.getMucXacDinh);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới danh mục khac
     */
    themMucXacDinh(requestBody) {
      return super.post(apiUrl.danhMuc.themMucXacDinh, requestBody);
    }

    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Cập nhật thông tin danh mục khac
     */
    capNhatMucXacDinh(requestBody) {
      return super.put(apiUrl.danhMuc.capNhatMucXacDinh, requestBody);
    }

    //ho gia dinh
    getDsNguonThu() {
      return super.get(apiUrl.danhMuc.KIEM_DINH.nguonThu);
    }

    getDsPhanLoaiDoiTuong() {
      return super.get(apiUrl.danhMuc.KIEM_DINH.loaiDoiTuong);
    }

    getAllTrangThaiQuyTrinh() {
      return super.get(apiUrl.danhMuc.KIEM_DINH.getAllTrangThaiQuyTrinh);
    }

    //ho gia dinh new
    getDsNguonThuNew() {
      return super.get(apiUrl.danhMuc.nguonThu);
    }

    getDsPhanLoaiDoiTuongNew() {
      return super.get(apiUrl.danhMuc.loaiDoiTuong);
    }

    getAllTrangThaiQuyTrinhNew() {
      return super.get(apiUrl.danhMuc.getAllTrangThaiQuyTrinh);
    }

    getChiTietNgheo() {
      return super.get(apiUrl.danhMuc.phanLoaiHoNgheo);
    }
}
